module.exports = __webpack_public_path__ + "6d1f5a90.png";